import { render } from "./trainingAddCourseModal.vue?vue&type=template&id=a43f7190&ts=true"
import script from "./trainingAddCourseModal.vue?vue&type=script&lang=ts"
export * from "./trainingAddCourseModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__